import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ConvertIcon } from '@work4all/assets/icons/convert.svg';

import { IconButtonWithTooltip } from '../IconButtonWithTooltip';
import { BaseActionProps } from '../types';

export const Convert: React.FC<BaseActionProps> = (props) => {
  const { t } = useTranslation();
  return (
    <IconButtonWithTooltip
      tooltip={t('MASK.CONVERT')}
      icon={<ConvertIcon style={{ height: '1.5rem', width: '1.5rem' }} />}
      {...props}
    />
  );
};
